import type { GasPayload } from '@atlaskit/analytics-gas-types';

/** `stale`: the last stored prompts are shown instead; `none`: there was nothing to fall back on. */
export type PromptOfTheDayFallback = 'stale' | 'none';

export const onPromptOfTheDayTaskFail: ({
	attributes,
	fallback,
}: {
	attributes: Record<string, unknown>;
	fallback: PromptOfTheDayFallback;
}) => GasPayload = ({ attributes, fallback }) => ({
	source: 'searchDialog',
	eventType: 'operational',
	action: 'taskFail',
	actionSubject: 'promptOfTheDay',
	actionSubjectId: 'preQuerySearchResults',
	attributes: { ...attributes, fallback },
});
